import React from 'react';
import ReactDOM from 'react-dom';

import SupportChatbot from '~chatbot';

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('chatbot-root');
  const chatbotSlug = rootElement?.getAttribute('data-chatbot-slug');
  const extraClass = rootElement?.getAttribute('data-extra-class');

  ReactDOM.render(
    <SupportChatbot chatbotSlug={chatbotSlug} extraClass={extraClass} />,
    rootElement,
  );
});

if (process.env.NODE_ENV === 'development') {
  module.hot.accept();
}
